<template>
  <section class="equity-calculator-controls">
    <preset-community-cards-selector
      v-if="!shortDeck"
      v-bind:presetHoleCards="this.presetHoleCards"
      v-bind:presetCommunityCards="presetCommunityCards"
      v-bind:popoverDirectionClass="'dropdown'"
      v-bind:disabled="disabled"
      v-on:setIndividualPresetCommunityCard="$emit('setIndividualPresetCommunityCard', $event)"
      v-on:setBoard="$emit('setBoard', $event)"
      v-on:removePresetCommunityCard="$emit('removePresetCommunityCard', $event)"
    />
    <short-deck-preset-community-cards-selector
      v-else-if="shortDeck"
      v-bind:presetHoleCards="this.presetHoleCards"
      v-bind:presetCommunityCards="presetCommunityCards"
      v-bind:popoverDirectionClass="'dropdown'"
      v-bind:disabled="disabled"
      v-on:setIndividualPresetCommunityCard="$emit('setIndividualPresetCommunityCard', $event)"
      v-on:setBoard="$emit('setBoard', $event)"
      v-on:removePresetCommunityCard="$emit('removePresetCommunityCard', $event)"
    />
    <add-player-button
      v-bind:disabled="disabled"
      v-on:addPlayer="$emit('addPlayer')"
    />
    <create-sharable-url-button
      v-bind:disabled="disabled || !hasSimulationBeenRun"
      v-on:createSharableUrl="$emit('createSharableUrl')"
    />
    <!--
    <save-scenario-button
      v-bind:savedScenario="savedScenario"
      v-bind:disabled="disabled || !hasSimulationBeenRun || !loggedIn"
      v-on:saveScenario="$emit('saveScenario')"
      v-on:updateScenario="$emit('updateScenario')"
    />
    -->
    <simulate-button
      v-bind:disabled="disabled"
      v-on:simulate="$emit('simulate')"
    />
  </section>
</template>

<script>
import PresetCommunityCardsSelector from '@/components/controls/card-selection/preset-community-cards-selector';
import ShortDeckPresetCommunityCardsSelector from '@/components/short-deck/short-deck-preset-community-cards-selector';
import AddPlayerButton from '@/components/controls/add-player-button';
import CreateSharableUrlButton from '@/components/controls/create-sharable-url-button';
import SaveScenarioButton from '@/components/controls/save-scenario-button';
import SimulateButton from '@/components/controls/simulate-button';
import PresetHoleCards from '@/services/PresetHoleCards';

export default {
  name: 'equity-calculator-controls',
  components: {
    'preset-community-cards-selector': PresetCommunityCardsSelector,
    'short-deck-preset-community-cards-selector': ShortDeckPresetCommunityCardsSelector,
    'add-player-button': AddPlayerButton,
    'create-sharable-url-button': CreateSharableUrlButton,
    'save-scenario-button': SaveScenarioButton,
    'simulate-button': SimulateButton,
  },
  props: ['presetCommunityCards', 'hasSimulationBeenRun', 'savedScenario', 'disabled', 'shortDeck', 'loggedIn'],
  data: function () {
    return {
      presetHoleCards: new PresetHoleCards(),
    };
  },
};
</script>

<style lang="scss" scoped>
  .equity-calculator-controls {
    & /deep/ .add-player-button-container .add-player-button {
      height: 44px;
      width: 150px;
      font-size: 16px;
    }

    & /deep/ .create-sharable-url-button-container .create-sharable-url-button {
      height: 44px;
      width: 200px;
      font-size: 16px;
    }

    & /deep/ .save-scenario-button-container .save-scenario-button {
      height: 44px;
      width: 150px;
      font-size: 16px;
    }

    & /deep/ .simulate-button-container {
      .simulate-button, .progress-box {
        height: 44px;
      }

      .text {
        font-size: 16px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/equity-calculator/controls.vue